import LogoGroow from "components/ui/v2/sidebar/sidebar-logo";
import { Sparkles, Target, TrendingUp } from "lucide-react";
import useTranslation from "next-translate/useTranslation";

export default function BrandPanelAurora() {
  const { t } = useTranslation("vendor");

  const bullets = [
    { icon: Sparkles, text: t("Conecta y reconoce a tu equipo") },
    { icon: Target, text: t("Evalúa el desempeño con claridad") },
    { icon: TrendingUp, text: t("Impulsa el desarrollo profesional") },
  ];

  return (
    <div className="relative hidden overflow-hidden rounded-[28px] border border-white/10 bg-gradient-to-br from-indigo-600 via-violet-600 to-fuchsia-600 p-8 md:flex md:flex-col md:justify-between">
      <div aria-hidden className="pointer-events-none absolute inset-0">
        <div className="absolute -left-10 -top-10 h-52 w-52 rounded-full bg-cyan-300/30 blur-3xl" />
        <div className="absolute -bottom-12 -right-8 h-56 w-56 rounded-full bg-fuchsia-300/30 blur-3xl" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,rgb(255_255_255/0.14)_1px,transparent_0)] bg-[length:22px_22px] opacity-40" />
      </div>

      <div className="relative z-10">
        <LogoGroow redirect={false} dark marginLeft="0px" hideVendorInfo />
      </div>

      <div className="relative z-10 mt-10 flex flex-col gap-6">
        <h2 className="text-balance text-3xl font-bold leading-tight text-white">
          {t("Crea tu organización en Groowcity")}
        </h2>
        <ul className="flex flex-col gap-4">
          {bullets.map(({ icon: Icon, text }) => (
            <li key={text} className="flex items-center gap-3 text-white/90">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-white/15 backdrop-blur-sm">
                <Icon className="h-4 w-4" />
              </span>
              <span className="text-sm font-medium">{text}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
